export function getServiceUnavailableErrorInfo (error) {
    const networkError = error?.networkError || error
    const response = networkError?.response || error?.response

    const statusCode = networkError?.statusCode
        || response?.status
        || error?.statusCode

    const headers = response?.headers
        || networkError?.result?.headers
        || error?.response?.headers

    const maxMaintenance = headers?.get?.('max-maintenance')

    return {
        isServiceUnavailable: statusCode === 503,
        isMaintenance: Boolean(maxMaintenance),
    }
}

export async function checkApiAvailability () {
    const response = await window.fetch(process.env.VUE_APP_GRAPHQL_HTTP || 'http://localhost:4000/graphql', {
        method: 'POST',
        credentials: 'include',
        headers: {
            'Content-Type': 'application/json',
            'TenantDomain': process.env.VUE_APP_TENANT_DOMAIN || window.location.hostname,
        },
        body: JSON.stringify({
            query: 'query CheckApiAvailability { __typename }',
        }),
    })

    const isMaintenance = Boolean(response.headers.get('max-maintenance'))

    return {
        isAvailable: response.ok && response.status !== 503,
        isMaintenance,
    }
}
